
export default {
  async asyncData({ params, $axios, error }) {
    try {
      const article = await $axios.$get(`/public/articles/${params.slug}`);

      return {
        article,
      };
    } catch (e) {
      console.error(e);
      error({ statusCode: 404, message: 'Not found' });
    }
  },

  data() {
    return {
      articles: [],
      isLoading: false,
      total: 0,
      page: 1,
      perPage: 15,
    };
  },

  head() {
    if (this.article) {
      const title = `${this.article.title} | ${this.$config.title}`;
      const description = this.article.description;
      const image = this.article.heroImage ? `${this.$config.IMAGEKIT}/tr:w-1400,h-780/${this.article.heroImage}` : false;
      return {
        title,
        meta: [
          { hid: 'og:title', property: 'og:title', content: title },
          { hid: 'description', name: 'description', content: description },
          { hid: 'og:description', property: 'og:description', content: description },
          { hid: 'twitter:description', property: 'twitter:description', content: description },
          image ? { hid: 'og:image', property: 'og:image', content: image } : {},
          image ? { hid: 'twitter:image', property: 'twitter:image', content: image } : {},
        ],
      };
    }

    return {};
  },

  computed: {
    countArticles() {
      return this.articles ? this.articles.length : 0;
    },
  },

  watch: {
    article: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },

  methods: {
    async load() {
      try {
        const response = await this.$axios.$get('/public/articles', {
          params: {
            limit: this.perPage,
            except: this.article.id,
          },
        });

        this.articles = response.results;
        this.total = response.total;
      } catch (error) {
        console.error(error);
      }
    },
    async showMore() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      const response = await this.$axios.$get('/public/articles', {
        params: {
          skip: this.page * this.perPage,
          limit: this.perPage,
          except: this.article.id,
        },
      });

      this.page = this.page + 1;

      this.articles.push(...response.results);

      this.isLoading = false;
    },
  },
};
